import {PersistentStorage} from '@/ts/utils/persistent-storage';

/** Singleton PersistentStorage instance backed by localStorage. */
export const persistentStorage: PersistentStorage = new PersistentStorage();
